import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getLinkedLicensingMailboxInfoOrSelf, isBusiness } from "owa-session-store";
import { isCopilotLicensedAndEnabledUser } from "./isCopilotLicensedAndEnabledUser";

export function isMeetingBriefingPreviewEnabledForMailbox(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("time-copilot-meeting-briefing-preview") &&
        isBusiness(mailboxInfo) &&
        isCopilotLicensedAndEnabledUser(getLinkedLicensingMailboxInfoOrSelf(mailboxInfo)));
}
